/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios';
import { API_URL, APIV, STATUS_CODES,API_VERSION_V2,COUNTRY_CODE } from '@src/config/constant';
import secureStorage from '@src/config/encrypt';
import { toast } from 'react-toastify';
import * as HELPER from "@src/config/helper";
import { GATEWAY_APIS } from '@src/config/id/constant';
const isCountryId = COUNTRY_CODE ==='id' ? true : false;



const Axios = axios.create();
Axios.interceptors.response.use(
    (response) => {
        if (response.data && response?.data?.status === STATUS_CODES['failure'] && response?.data?.error === "keys_expired") {
            window.location.reload()
        }
        
        if(response && response.headers && +response.headers.isresponseencrypted){ 
            
            response.data = HELPER.DecryptResponse(response)

        }else{
            
        }
        return response;
    },
    (error) => {

        // handle error
        if (error.response) {

            if (+error.response.status === STATUS_CODES['unavailable']) {
            } else if (+error.response.status === STATUS_CODES['unauthorized']) {
                secureStorage.removeItem('authAgentUserInfo');
                window.location.href = '/login';
            }else if (+error.response.status === STATUS_CODES['failure']) {
                let errorDecrypt = HELPER.DecryptResponse(error.response)
                error.response.data = errorDecrypt?.data || errorDecrypt; 
            }

        }

        return error.response;
    });

(window as any).commonErrorToast = function (error: any) {
    if (typeof error == "string") toast.error(error);
    else if (error.message) toast.error("Helllo", error.message);
}
const MasterService = {

    getToken() {
        return (secureStorage.getItem('authAgentUserInfo') && secureStorage.getItem('authAgentUserInfo')['token'])
            ? secureStorage.getItem('authAgentUserInfo')['token']
            : ''
    },
    delete(URL: string, body: object, headers: any) {
        headers = headers || {};
        if (APIV) headers['apiv'] = APIV;
        headers['Authorization'] = this.getToken();
        headers['Accept-Language'] = secureStorage.getItem('lang') || 'en';
        // headers['apikey'] = apikey;
        URL = (URL[0] === '/') ? URL.substring(1) : URL;
        return Axios.delete(`${API_URL.GETWAY_API}${URL}`, { data: body, headers })
    },
    post: async (URL: string, body?: object, headers?: any) => {
        headers = headers || {};
        if (APIV) headers['apiv'] = APIV;
        headers['Authorization'] = MasterService.getToken();
        headers['Accept-Language'] = secureStorage.getItem('lang') || 'en';
        headers['x-api-version'] = API_VERSION_V2;
        //headers['apikey'] = apikey;
        headers['app_type'] = COUNTRY_CODE;

        let baseUrl:any = API_URL.GETWAY_API
        if(isCountryId && GATEWAY_APIS.includes(URL)){
            baseUrl = API_URL.GETWAY_URL
        }
        
        
        URL = (URL[0] === '/') ? URL.substring(1) : URL;

        let encryptedData: any =  {body, headers}
        if(baseUrl === API_URL.GETWAY_URL){
            encryptedData = {body, headers}
        }
        return Axios.post(`${baseUrl}${URL}`, encryptedData?.body, { headers: encryptedData.headers })
    },
    put(URL: string, body?: object, headers?: any) {
        headers = headers || {};
        if (APIV) headers['apiv'] = APIV;
        headers['Authorization'] = this.getToken();
        headers['Accept-Language'] = secureStorage.getItem('lang') || 'en';
        // headers['apikey'] = apikey;
        URL = (URL[0] === '/') ? URL.substring(1) : URL;
        return Axios.put(`${API_URL.GETWAY_API}${URL}`, body, { headers })
    },
    get: async (URL: string, query?: any, headers?: any) => {
        headers = headers || {};
        if (APIV) headers['apiv'] = APIV;
        headers['Authorization'] = MasterService.getToken();
        headers['Accept-Language'] = secureStorage.getItem('lang') || 'en';
        headers['x-api-version'] = API_VERSION_V2;
        headers['app_type'] = COUNTRY_CODE;
        //headers['apikey'] = apikey;
        URL = (URL[0] === '/') ? URL.substring(1) : URL;

        let encryptedData: any = (URL.indexOf("getPublicKey") === -1) ? await MasterService.encryptRequestData(URL, headers, query) : {body: query, headers}

        return Axios.get(`${API_URL.GETWAY_API}${URL}`,
            { params: encryptedData.body, headers: encryptedData.headers })
    },

    encryptRequestData: async (URL: string, headers: any, body: any) => {
        return new Promise(async (resolve)=>{

            let encryptedReqData = "";
            let encPubKey = secureStorage.getItem('encryptionPublicKey');

            if(URL.indexOf('/getPublicKey') === -1){

                // body = body && Object.keys(body).length ? JSON.stringify(body) : "";
                let {encryptedReqData, iv, symmetricKey} = HELPER.encryptAesKey({encPubKey, body, headers, URL});
                headers['isresponseencrypted'] = (typeof headers['isresponseencrypted'] !== 'undefined') ? headers['isresponseencrypted'] : 1;
                headers['encryptedIV'] = iv;
                headers['encryptedSymmetricKey'] = symmetricKey;
                body = {requestData:encryptedReqData};

                if(encryptedReqData instanceof FormData){

                        body = encryptedReqData//{requestData:encryptedReqData};
                }

                //if(encryptedReqData)

                resolve({body, headers, encryptedReqData})
            }else{
                resolve({body, headers, encryptedReqData})
            }
        })
    }
}

export default MasterService;
